import sourceMarker from "@/assets/map/source.png";
import destinationsMarker from "@/assets/map/destinations.png";
import destinationMarker from "@/assets/map/destination.png";
import defaultMarker from "@/assets/map/default.png";
import blueDot from "@/assets/map/dot.png";
// import BranchIcon from "@/assets/map/BranchIcon.png";
// import DriverHomeIcon from "@/assets/map/DriverHomeIcon.png";
import LoadingIcon from "@/assets/map/LoadingIcon.png";
import OffLoadingIcon from "@/assets/map/OffLoadingIcon.png";
import WarehouseIcon from "@/assets/map/Warehouse.png";

import BranchIcon from "@/assets/map/Branch.png";
import TruckIcon from "@/assets/map/TruckNew.png";
import DriverIcon from "@/assets/map/Driver.png";
import customerIcon from "@/assets/map/customer.png";
import DriverHomeIcon from "@/assets/map/Driver-home.png";
import TripStartLocationIcon from "@/assets/map/TripStartLocation.png";
import TripEndLocationIcon from "@/assets/map/TripEndLocation.png";

// Order Icons
import OrderAssignedIcon from "@/assets/map/Order_Assigned.png";
import OrderEnrouteIcon from "@/assets/map/Order_Enroute.png";
import OrderNotDelivered from "@/assets/map/Order_Not_delivered.png";

import OrderReturned from "@/assets/map/Order_Returned.png";

import OrderPickupIcon from "@/assets/map/Order_Pickup.png";
import OrderNotPickedupIcon from "@/assets/map/Order_Not_pickedup.png";
import OrderSuccessfulIcon from "@/assets/map/Order_Successful.png";
import OrderUnassignedIcon from "@/assets/map/Order_Unassigned.png";

import OrderOpenTransaction from "@/assets/map/Opne_Transaction.png";

import OrderCancelledIcon from "@/assets/map/Order_cancelled.png";
import orderPartiallyDeliveredIcon from "@/assets/map/order_partially_delivered.png";
import orderOnHoldIcon from "@/assets/map/on_hold.png";

// Trip Icons
import TripActiveIcon from "@/assets/map/Trip_Active.png";
import TripCompletedIcon from "@/assets/map/Trip_Completed.png";
import TripPausedIcon from "@/assets/map/Trip_Paused.png";
import TripScheduledIcon from "@/assets/map/Trip_Scheduled.png";

// Trip planning
import TripPlanningLocationIcon from "@/assets/map/Location.png";

import CustomerLocationIcon from "@/assets/map/customerMaker.png";
import SingleCustomerIcon from "@/assets/map/customerMaker2.png";
import PlannedLocation from "@/assets/map/plannedLocation.png";
import UnplannedLocation from "@/assets/map/old_location.png";

import OldLocation from "@/assets/map/old_location.png";
import UpdatedLocation from "@/assets/map/plannedLocation.png";

// Operations
import Active from "@/assets/map/active.png";
import ActiveConnectionLost from "@/assets/map/active_connection_lost.png";
import Paused from "@/assets/map/paused.png";
import PausedConnectionLost from "@/assets/map/paused_connection_lost.png";
import Loading from "@/assets/map/loading.png";
import LoadingConnectionLost from "@/assets/map/loading_connection_lost.png";
import LoadingCompleted from "@/assets/map/loading_completed.png";

import vehicleTrailer from "@/assets/vehicle.svg";
// import LoadingCompletedConnectionLost from "@/assets/map/loading_connection_lost.png"

const iconsMap = {
  assigned: OrderAssignedIcon,
  unassigned: OrderUnassignedIcon,
  "picked up": OrderPickupIcon,
  pickedup: OrderPickupIcon,
  "not pickedup": OrderNotPickedupIcon,
  not_pickedup: OrderNotPickedupIcon,
  partially_delivered: orderPartiallyDeliveredIcon,
  "partially delivered": orderPartiallyDeliveredIcon,
  pickup_order: sourceMarker,
  drop_order: destinationsMarker,
  on_hold: orderOnHoldIcon,
  returned: OrderReturned,
  open_transaction: OrderOpenTransaction,
  "out for delivery": OrderEnrouteIcon,
  enroute: OrderEnrouteIcon,
  delivered: OrderSuccessfulIcon,
  not_delivered: OrderNotDelivered,
  "not delivered": OrderNotDelivered,
  cancelled: OrderCancelledIcon,
  "Driver Home": DriverIcon,
  customer: customerIcon,
  "Customer Address": customerIcon,
  Loading: WarehouseIcon,
  "Loading Completed": WarehouseIcon,
  "Off Loading": customerIcon,
  Order: customerIcon,
  warehouse: WarehouseIcon,
  Warehouse: WarehouseIcon,
  Branch: BranchIcon,
  driver: TruckIcon,
  operationsActive: Active,
  operationsActiveConnectionLost: ActiveConnectionLost,
  operationsLoading: Loading,
  operationsLoadingConnectionLost: LoadingConnectionLost,
  operationsLoadingCompleted: LoadingCompleted,
  operationsLoadingCompletedConnectionLost: LoadingCompleted,
  operationsPaused: Paused,
  operationsPausedConnectionLost: PausedConnectionLost,
  planned_order: PlannedLocation,
  unplanned_order: UnplannedLocation,
  old_location: OldLocation,
  updated_location: UpdatedLocation,
  driverHome: DriverHomeIcon,
  other: SingleCustomerIcon,
  vehicleTrailer: vehicleTrailer,
  "Trip Start Location": TripStartLocationIcon,
  "Trip End Location": TripEndLocationIcon,
};

export {
  vehicleTrailer,
  iconsMap,
  sourceMarker,
  destinationMarker,
  destinationsMarker,
  defaultMarker,
  blueDot,
  BranchIcon,
  LoadingIcon,
  OffLoadingIcon,
  customerIcon,
  DriverIcon,
  DriverHomeIcon,
  WarehouseIcon,
  TruckIcon,
  OrderAssignedIcon,
  OrderCancelledIcon,
  OrderEnrouteIcon,
  OrderNotDelivered,
  OrderPickupIcon,
  OrderNotPickedupIcon,
  OrderSuccessfulIcon,
  OrderUnassignedIcon,
  OrderOpenTransaction,
  orderPartiallyDeliveredIcon,
  orderOnHoldIcon,
  OrderReturned,
  TripActiveIcon,
  TripCompletedIcon,
  TripPausedIcon,
  TripScheduledIcon,
  TripPlanningLocationIcon,
  CustomerLocationIcon,
  PlannedLocation,
  UnplannedLocation,
  OldLocation,
  UpdatedLocation,
  SingleCustomerIcon,
  Active,
  ActiveConnectionLost,
  Paused,
  PausedConnectionLost,
  Loading,
  LoadingConnectionLost,
  LoadingCompleted,
  TripStartLocationIcon,
  TripEndLocationIcon,
};
